import React from 'react'
import { Grid } from '@material-ui/core'
import { Bar } from 'react-chartjs-2'

import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'

import * as Utils from 'src/utils/chartsUtils'
import TableAAPPMEI from '../../Tables/TableAAPPMEI'
import TableAAPP from '../../Tables/TableAAPP'

const MEIElectricBikesCard = props => {
  const { table1, table2, selectedDate, gMei1, gMei1A, gMei1B } = props
  return (
    <Card>
      <CardBody>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} sm={12} lg={12}>
            <div>
              <h3>SELL IN y SELL OUT BICICLETAS ELÉCTRICAS</h3>
            </div>
            <br />
            <TableAAPPMEI array={table1} selectedDate={selectedDate} param="MES" />
          </Grid>
          <Grid item xs={12} sm={12} lg={10}>
            <h3>Participación del mercado - años</h3>
            <br />
            <Bar
              data={Utils.simpleBarLine(gMei1, 'YYYY', 'VALOR', '', 'Año', 1)}
              options={Utils.optionsSimpleBarChart}
            />{' '}
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <div>
              <h3>SELL IN y SELL OUT BICICLETAS ELÉTRICAS POR TERRITORIO</h3>
            </div>
            <br />
            <TableAAPP array={table2} selectedDate={selectedDate} param="TERRITORIO" colParam AA />
          </Grid>
          <Grid item xs={12} sm={12} lg={10}>
            <h3>Mix por zonas - años</h3>
            <br />
            <Bar
              data={Utils.customBarLineDataGroup(gMei1A, 'TERRITORIO', 'MIX', 'YYYY', '100')}
              options={Utils.optionsGroupedCharts}
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={10}>
            <h3>Mix por zonas - mes</h3>
            <br />
            <Bar
              data={Utils.customBarLineDataGroup(gMei1B, 'TERRITORIO', 'MIX', 'MESC', '100')}
              options={Utils.optionsGroupedCharts}
            />
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  )
}

export default MEIElectricBikesCard
